import { request, downloadRequest } from '@/utils/request'

/* export const reqCustomerType = code =>
  firebaseRequest.get(`complaint?code=${code}`); */

export const reqDriverList = () => request.get(`driver/list?task=general`)

export const reqTaxiMeter = (params) =>
  request.get(`driver/taxi_meter`, { params })

// 大量作業：裝錶跳錶報表匯出
export const reqTaxiMeterDownload = (params) =>
  downloadRequest.post('excel/driver_taxi_meter-excel', null, { params })



// WEBPACK FOOTER //
// ./src/API/searchDriverMeter/index.js